import React from "react";

import { UilLocationPoint } from "@iconscout/react-unicons";
import styles from "./LocationPicker.module.scss";

function LocationPicker() {
  const clickHandler = (event: any) => {
    event.preventDefault();

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        console.log(position);
        alert(
          "Your location is: " +
            position.coords.latitude +
            ", " +
            position.coords.longitude
        );
      });

      return;
    } else {
      // TODO: Toastify;
      console.log("Geolocation is not supported by this browser.");
    }
  };

  return (
    <button className={styles["container"]} onClick={clickHandler}>
      <UilLocationPoint className={styles["container__icon"]} />
    </button>
  );
}

export default LocationPicker;
